import ActionTypes from "../constants/action_types";
import basePath from "base_path";
import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {ProjectId} from "common/types/project";
import {DocumentId} from "common/types/document";

export default function resetAppliedAmendments(requestor) {
  return createReduxPromiseAction(
    ActionTypes.DOCUMENT_ISSUE_RESET_APPLIED_AMENDMENTS,
    (
      organisationId: OrganisationId,
      projectId: ProjectId,
      documentId: DocumentId,
    ) => {
      return requestor
        .patch(
          `${basePath}/organisation/${organisationId}/project/${projectId}/document/${documentId}/amendment/reset`,
          {},
          {withCredentials: true},
        )
        .then(response => response.data);
    },
  );
}
